var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"tooltip",staticClass:"tooltip",class:{
    'tooltip--visible': _vm.visible,
    'tooltip--shallow-margin': _vm.shallowMargin,
    'tooltip--no-margin': _vm.noMargin
  }},[_c('div',{staticClass:"tooltip__content"},[_vm._t("default",[_c('span',{staticClass:"tooltip__text"},[_vm._v(_vm._s(_vm.content))])])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }